import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-558991bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label" }

import gsap from 'gsap';
  import { ref } from 'vue'

  interface Option {
    weight: number
    label: string
    colors: boolean | string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const options: Option[] = [
    { weight: 15, label: 'Left Foot', colors: true },
    { weight: 15, label: 'Left Hand', colors: true },
    { weight: 15, label: 'Right Foot', colors: true },
    { weight: 15, label: 'Right Hand', colors: true },
    { weight: 30, label: 'Strip', colors: true },
  ]

  const table: number[] = []
  let tableTotal = 0

  // Generate Table
  for (let i = 0; i < options.length; i++) {
    const option: Option = options[i];

    table.push(option.weight + tableTotal)

    tableTotal += option.weight;
  }

  console.log(table)

  const colors: string[] = ['red', 'blue' , 'yellow', 'green']
  let colorIndex = 0

  const getRandomOption = () => {
    colorIndex++
    console.log(colorIndex % (colors.length))
    let option: {
      label: string,
      color: string
    } = {
      label: '',
      color: ''
    }

    // @ts-ignore
    const r = Math.floor(Math.random() * Math.max(...table))

    // Loop through table
    for (let i = 0; i < table.length; i++) {
      if (r < table[i]) {
        option = {
          label: options[i].label,
          // @ts-ignore
          color: options[i].colors == true ? colors[colorIndex % (colors.length)] : options[i].colors
        }

        break;
      }
    }

    return option;
  }

  const state = ref<{
    label: string
    color: string
  }>({
    label: 'Press To Start',
    color: 'red'
  })

  const randomize = () => {
    let count = { value: 0 }
    let prev = '0'

    colorIndex += Math.floor(Math.random() * colors.length);

    gsap.to(count, {
      value: 20,
      ease: 'power3.out',
      duration: 3,
      onUpdate: (prop) => {
        if (count.value.toFixed(0) != prev) {
          state.value = getRandomOption()

          prev = count.value.toFixed(0)
        }
      },
      onComplete: () => {
        gsap.to('.label', {
          scale: 1.6,
          rotate: 'random(-10deg, 10deg)',
          ease: 'expo.out',
          duration: 0.5,
          repeat: 1,
          yoyo: true
        })
      }
    })
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["game", state.value.color]),
    onClick: randomize
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(state.value.label), 1)
  ], 2))
}
}

})